<template>
  <div>
    <search-block :title="'пользователя по организации или логину'">
      <div class="searchRow">
        <div class="searchField">
          <el-select
            clearable
            @change="onOrganizationChange"
            class="searchPole"
            v-model="search.organization"
            filterable
            remote
            value-key="organizationInfo.id"
            reserve-keyword
            placeholder="Введите название организации"
            :remote-method="searchOrganization"
          >
            <el-option
              v-for="item in organizations.content"
              :key="item.id"
              :label="item.organizationInfo.name"
              :value="item"
            >
            </el-option>
          </el-select>
        </div>
        <div class="searchField">
          <el-autocomplete
            ref="usernameInput"
            clearable
            class="searchPole"
            v-model="search.username"
            value-key="username"
            select-when-unmatched
            :trigger-on-focus="hasOrganization"
            :fetch-suggestions="fetchUsernameSuggestions"
            :placeholder="
              hasOrganization
                ? 'Выберите или введите логин пользователя'
                : 'Введите логин пользователя'
            "
            @select="onUsernameSelect"
            @clear="onUsernameClear"
          ></el-autocomplete>
        </div>
        <el-button @click="createAdminUser" type="primary"
          >Добавить пользователя</el-button
        >
      </div>
    </search-block>

    <custom-modal
      :title="'Добавить пользователя'"
      :visible="showModal === 'createAdminUser'"
      v-if="showModal === 'createAdminUser'"
    >
      <users-add></users-add>
    </custom-modal>
  </div>
</template>

<script>
import SearchBlock from "@/components/searchBlock";
import { mapGetters } from "vuex";
import UsersAdd from "@/components/admin/users/usersAdd";
import CustomModal from "@/components/customModal";
export default {
  name: "usersSearch",
  components: { CustomModal, UsersAdd, SearchBlock },
  data() {
    return {
      createModalShow: false,
      search: {
        organization: {},
        username: "",
      },
      organizationUsers: Promise.resolve([]),
    };
  },

  computed: {
    ...mapGetters({
      organizations: "GETORGANIZATIONS",
      showModal: "GETSHOWMODAL",
      usersFilter: "GETUSERSFILTER",
      usersChangedAt: "GETUSERSCHANGEDAT",
    }),

    hasOrganization() {
      return !!(
        this.search.organization && this.search.organization.organizationInfo
      );
    },
  },

  watch: {
    usersFilter(filter) {
      // Фильтр по логину сняли (например, после удаления) — очищаем поле
      if (filter.action !== "searchUserByUsername") {
        this.search.username = "";
      }
    },

    usersChangedAt() {
      if (this.hasOrganization) {
        this.loadOrganizationUsers();
      }
    },
  },

  methods: {
    createAdminUser() {
      this.$store.dispatch("setShowModal", "createAdminUser");
    },

    clearSearch() {
      this.$store.dispatch("getAllUsers", {
        page: 0,
        size: 20,
      });
      this.search = {
        organization: {},
        username: "",
      };
    },

    onOrganizationChange() {
      this.search.username = "";
      if (this.hasOrganization) {
        this.searchUsersByOrganization();
        this.loadOrganizationUsers();
        // Открываем список логинов сразу после выбора организации
        this.$nextTick(() => this.$refs.usernameInput.focus());
      } else {
        this.organizationUsers = Promise.resolve([]);
        this.clearSearch();
      }
    },

    loadOrganizationUsers() {
      this.organizationUsers = this.$store
        .dispatch("getUsernameSuggestions", {
          username: "",
          organizationId: this.search.organization.organizationInfo.id,
          size: 1000,
        })
        .catch(() => []);
    },

    onUsernameSelect() {
      this.searchUsers();
    },

    onUsernameClear() {
      if (this.hasOrganization) {
        this.searchUsersByOrganization();
      } else {
        this.clearSearch();
      }
    },

    fetchUsernameSuggestions(query, callback) {
      // Подсказки показываются только для выбранной организации
      if (!this.hasOrganization) {
        callback([]);
        return;
      }
      const text = (query || "").trim().toLowerCase();
      this.organizationUsers.then((users) =>
        callback(
          users.filter((user) => user.username.toLowerCase().includes(text))
        )
      );
    },

    searchUsers() {
      if (this.search.username && this.search.username.trim()) {
        this.searchUsersByUsername();
      } else if (this.hasOrganization) {
        this.searchUsersByOrganization();
      }
    },

    searchUsersByUsername() {
      let data = {
        username: this.search.username.trim(),
        organizationId: this.hasOrganization
          ? this.search.organization.organizationInfo.id
          : undefined,
        page: 0,
        size: 20,
      };
      this.$store.dispatch("searchUserByUsername", data);
    },

    searchUsersByOrganization() {
      let data = {
        id: this.search.organization.organizationInfo.id,
        page: 0,
        size: 20,
      };
      this.$store.dispatch("searchUserByOrganizationId", data);
    },

    searchOrganization(query) {
      this.getOrganizationList(query);
    },

    getOrganizationList(query) {
      let data = {
        query: query,
        page: 0,
        size: 20,
      };
      this.$store.dispatch("searchOrganizations", data);
    },
  },
};
</script>

<style scoped>
.searchRow {
  display: flex;
  align-items: center;
  gap: 10px;
}

.searchField {
  flex: 1 1 0;
  min-width: 0;
}
</style>
